<div class="bread-crumb-image w-100 pb-5 pt-5" >
    <div class="container">
      <!-- uncomment for navigation breadcrumbs -->
      <nav>
        <ol class="breadcrumb ml-1 p-0 mb-0">
          <li class="breadcrumb-item">
            <a (click)="homeLinkClick(true)"  [routerLink]="['']">BHP Connect</a>
          </li>
        </ol>
      </nav>
      <h2 class="breadcrumb-page">{{pageTitle}}</h2>
    </div>
    </div>
    
    
    
